import React from "react";
import { Box, Typography } from "@mui/material";
import { colors } from "../utils/datosTheme";

function EmptyChartState() {
  return (
    <Box
      sx={{
        minHeight: 86,
        display: "grid",
        placeItems: "center",
        border: `1px dashed ${colors.line}`,
        borderRadius: "8px",
        color: colors.muted,
        bgcolor: "rgba(246,248,252,0.65)",
      }}
    >
      <Typography sx={{ fontWeight: 850, fontSize: 13 }}>
        Sin datos para el período
      </Typography>
    </Box>
  );
}

export default function ChartPanel({ title, children, empty = false }) {
  const chartHeight = empty ? 86 : 260;

  return (
    <Box
      sx={{
        border: `1px solid ${colors.line}`,
        borderRadius: "8px",
        backgroundColor: colors.panel,
        boxShadow: "0 10px 24px rgba(15, 42, 89, 0.07)",
        p: { xs: 1.5, sm: 2 },
        display: "flex",
        flexDirection: "column",
        minWidth: 0,
      }}
    >
      {typeof title === "string" ? (
        <Typography sx={{ color: colors.ink, fontWeight: 950, fontSize: 15, mb: 1.5 }}>
          {title}
        </Typography>
      ) : (
        <Box sx={{ mb: 1.5 }}>
          {title}
        </Box>
      )}
      <Box sx={{ height: chartHeight, minHeight: chartHeight }}>
        {empty ? <EmptyChartState /> : children}
      </Box>
    </Box>
  );
}
